"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderPayRequest = void 0;
var OrderPayRequest = /** @class */ (function () {
    function OrderPayRequest() {
    }
    return OrderPayRequest;
}());
exports.OrderPayRequest = OrderPayRequest;
;
//# sourceMappingURL=orderPay.request.js.map